import React from "react"
import { useTranslation } from "react-i18next"

import packageJSON from "../../../../package.json"

export const PortalVersion = React.memo(() => {
  const { t } = useTranslation()
  return (
    <div className="portal-version">
      {t("Portal.Version")}: {packageJSON.version}
    </div>
  )
})
